export default __webpack_public_path__ + "static/media/teeth.e06ab306.svg";